import { CardWrapper } from './card-wrapper';
import Image from 'next/image';
import { useAtomValue } from 'jotai';
import { workerMediaAtom } from '../global-state.worker-data';
import { WorkerDataLoader } from './worker-data-loader';
import { Alert } from '@restworld/ui-ds-base';
import { customImageLoader } from '@restworld/utils-common';
import { useTranslation } from 'next-i18next';
import { useProfileCommonIntl } from './hooks';
import { useFetchWorkerDataLoading } from '../../hooks';

export const MediaSection = () => {
  const { t } = useTranslation();
  const { missingInfoText } = useProfileCommonIntl();
  const workerDataLoading = useFetchWorkerDataLoading();
  const mediaData = useAtomValue(workerMediaAtom);
  const { isWorkerMediaInfoMissing: isInformationMissing } = useIsWorkerMediaInfoMissing();

  return (
    <CardWrapper title={t('onboarding-page:your_media')} editPageType="media">
      <div id="media" className="flex flex-col items-start justify-start pt-4">
        {isInformationMissing && !workerDataLoading && <Alert text={missingInfoText} className="mb-4" />}
        {workerDataLoading && <WorkerDataLoader />}
        {!workerDataLoading && !isInformationMissing && (
          <Image
            src={mediaData?.picture}
            width={240}
            height={200}
            alt="User profile image"
            className="rounded-lg"
            loader={customImageLoader}
          />
        )}
      </div>
    </CardWrapper>
  );
};

export function useIsWorkerMediaInfoMissing() {
  const mediaData = useAtomValue(workerMediaAtom);
  const isWorkerMediaInfoMissing = !mediaData?.picture;

  return { isWorkerMediaInfoMissing };
}
